/* eslint-disable max-len */
import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionnaireAQuestionsIds";

export const questionnaireAMasterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IsTheEmployeeCurrentlyAtWorkAndNotAbsentFromWorkDueToSickness,
        questionText: "Is the employee currently at work and not absent from work due to sickness?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhichOfTheFollowingBestDescribesTheIndividualsCurrentSituation,
        questionText: "Which of the following best describes the individual’s current situation?",
        canBeDisabled: false
    },
    {
        id: questionIds.AtWorkDidReportAndRecommendationsHelpYouSupportTheIndividualWithTheirHealthConditionAtWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help you to support the individual with their health condition at work?",
        canBeDisabled: false
    },
    {
        id: questionIds.AtWorkDidReportAndRecommendationsHelpYouPreventAnyFurtherAbsenceFromWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help prevent any further absence from work?",
        canBeDisabled: false
    },
    {
        id: questionIds.WhichOfTheBelowBestDescribesWhyTheEmployeeIsNotAtWork,
        questionText: "Which of the below best describes why the employee is not at work?",
        canBeDisabled: false
    },
    {
        id: questionIds.NotAtWorkDidReportAndRecommendationsHelpYouSupportTheIndividualWithTheirHealthConditionAtWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help you to support the individual with their health condition at work?",
        canBeDisabled: false
    },
    {
        id: questionIds.DontKnowDidReportAndRecommendationsHelpYouSupportTheIndividualWithTheirHealthConditionAtWork,
        questionText: "In your opinion did the report and recommendations from Occupational Health help you to support the individual with their health condition at work?",
        canBeDisabled: false
    }
];
